import { render, staticRenderFns } from "./AutotagSource.vue?vue&type=template&id=b5e3098e&scoped=true"
import script from "./AutotagSource.vue?vue&type=script&lang=js"
export * from "./AutotagSource.vue?vue&type=script&lang=js"
import style0 from "./AutotagSource.vue?vue&type=style&index=0&id=b5e3098e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e3098e",
  null
  
)

export default component.exports